import { HttpEvent, HttpHandlerFn, HttpInterceptorFn, HttpRequest } from '@angular/common/http';

import { environment } from '../../../environments/environment';
import { Observable } from 'rxjs';
import { LoadingService } from '../services/shared-services/loading.service';
import { inject } from '@angular/core';


export function jwtInterceptor(req: HttpRequest<unknown>, next: HttpHandlerFn): Observable<HttpEvent<unknown>> {
 
  // Define your base URLs
  let baseUrl = '';
  const clientTemplateDomain = environment.clientTemplateDomain;
  const apiUrl = environment.apiUrl;
 
  // Conditional logic to determine which base URL to use
  if (req.url.includes('cp/api')) {
    baseUrl = clientTemplateDomain;
  } else if (req.url.includes('bocm/api')) {
      baseUrl = clientTemplateDomain;
  } else if (req.url.includes('api')) {
    baseUrl = apiUrl;
  } 

  req = req.clone({
    url: baseUrl + req.url
  })
  console.log("URL : "+req.url);
  return next(req);
}
  

